var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Toolbar',{attrs:{"esDocumento":true}}),_c('vue-pdf-embed',{attrs:{"source":_vm.urlDocumento}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }